import Decimal from './break_eternity.min.js'; // large number library
export const DEC = (num) => new Decimal(num); // shorten decimal declarations